import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';

type VariableWork = {
  hours28Days: string;
  hours29Days: string;
  hours30Days: string;
  hours31Days: string;
  hoursYearly: string;
};

type DefaultTrialConditionsProps = {
  error1: boolean;
  error2: boolean;
  error3: boolean;
  error4: boolean;
  error5: boolean;
  period: "月" | "年";
  title: string;
  value1: VariableWork;
  setValue1: (value: VariableWork) => void;
  place1: string;
  length: number;
  desc: string;
};

const DefaultTrialConditions: React.FC<DefaultTrialConditionsProps> = ({ error1, error2, error3, error4, error5, period, title, value1, setValue1, place1, length, desc }) => {

  const errorList = [ error1, error2, error3, error4, error5 ];

  return (
    <>
    <DefaultTitle
      title={title}
    />

    {period === "月" && (["28Days","29Days","30Days","31Days"] as const).map((dayKey, i) => (
      <div className={Styles.input} key={i}>
        <p>{dayKey.replace("Days","日")}</p>
        <input
          style={errorList[i] ? { border: ".5px solid #E31C5F" } : {}}
          className={Styles.input_allowance}
          placeholder={place1}
          maxLength={length}
          value={value1[`hours${dayKey}` as keyof VariableWork]}
          onChange={(e) => setValue1({ ...value1, [`hours${dayKey}`]: e.target.value })}
        />
        <p>時間 / 月</p>
      </div>
    ))}

    {period === "年" && (
      <div className={Styles.input}>
        <p>1年</p>
        <input
          style={errorList[4] ? { border: ".5px solid #E31C5F" } : {}}
          className={Styles.input_allowance}
          placeholder={place1}
          maxLength={length}
          value={value1.hoursYearly}
          onChange={(e) => setValue1({ ...value1, hoursYearly: e.target.value })}
        />
        <p>時間 / 年</p>
      </div>
    )}

    <p className={Styles.desc}>{desc}</p>
    </>
  );
}

export default DefaultTrialConditions;
